import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';


export const CustomerLeads = {
	name: NAME,
	apiProvider,
	router,
};
